import { isDevOrPreviewSite } from '../../utils/general'
import {
  F_API_KEY,
  F_CUSTOM_DOMAIN,
  F_EDIT_MODE,
  F_EMAIL_GATE,
  F_PWD_PROTECTION,
  F_FEEDBACK_MODE,
  F_MINIMALIST_MODE,
  F_PRESENTATION_MODE,
  F_TRACKED_LINKS,
  F_PDF_PAGE_ANALYTICS,
  F_DOWNLOAD_ANALYTICS,
  F_PDF_TO_WEBSITE,
  F_EMAIL_WHITELIST
} from './constants'

const isDev = isDevOrPreviewSite()

const PRO_U_PLAN = {
  id: isDev ? 'prod_J8kEW4NCKrP3nK' : 'prod_J8jz9uooW4PLna',
  label: 'Pro',
  prices: {
    yearly: {
      stripe: {
        usd: {
          symbol: '$',
          value: 372,
          priceId: isDev ? 'price_1KfVUXKnX1nnNv6IRgoMTn6b' : 'price_1KfVHbKnX1nnNv6I4wEA7d2K'
        },
        eur: {
          symbol: '€',
          value: 372,
          priceId: isDev ? 'price_1PVcRkKnX1nnNv6Iv9a19omc' : 'price_1PVckKKnX1nnNv6I0RlD65bk'
        },
        gbp: {
          symbol: '£',
          value: 300,
          priceId: isDev ? 'price_1PVcSqKnX1nnNv6IoRh7yoLC' : 'price_1PVckuKnX1nnNv6IlIl8w3Dp'
        },
        inr: {
          symbol: '₹',
          value: 15600,
          priceId: isDev ? 'price_1PVcTVKnX1nnNv6IQcFVtzyM' : 'price_1Q7FMRKnX1nnNv6IAxKI4Anp'
        }
      },
      paddle: { priceId: isDev ? 'pri_01kb25ng2bejpfp3hcg5wq6pdt' : 'pri_01kerz6gcvt1m36w7z9m304e13' },
      payPro: { priceId: isDev ? 103228 : 103227 }
    },
    monthly: {
      stripe: {
        usd: {
          symbol: '$',
          value: 38,
          priceId: isDev ? 'price_1KfVScKnX1nnNv6IzFaboaWJ' : 'price_1KfV77KnX1nnNv6Iw1tVuVWl'
        },
        eur: {
          symbol: '€',
          value: 38,
          priceId: isDev ? 'price_1PVcVsKnX1nnNv6IPKAeOd9O' : 'price_1PVcowKnX1nnNv6Isn1XgfqU'
        },
        gbp: {
          symbol: '£',
          value: 30,
          priceId: isDev ? 'price_1PVcWGKnX1nnNv6Iv0IzCrY0' : 'price_1PVcpOKnX1nnNv6I9EmmjNRt'
        },
        inr: {
          symbol: '₹',
          value: 1895,
          priceId: isDev ? 'price_1PVcVMKnX1nnNv6IVpgM42Mg' : 'price_1QiqtuKnX1nnNv6I2QRqvVe9'
        }
      },
      paddle: { priceId: isDev ? 'pri_01kb25mav7htdsdes3ddffecze' : 'pri_01kerz56ch7kfax621pm5c4j0r' },
      payPro: { priceId: isDev ? 103225 : 103226 }
    }
  },
  fileSizeLimit: 10000,
  customDomainsLimit: 5,
  projectLimit: 15,
  accountLimit: 10000,
  visitorLimit: 500000,
  bandwidthLimit: 100,
  features: {
    [F_CUSTOM_DOMAIN]: true,
    [F_PWD_PROTECTION]: true,
    [F_EDIT_MODE]: true,
    [F_API_KEY]: true,
    [F_EMAIL_GATE]: true,
    [F_FEEDBACK_MODE]: true,
    [F_PRESENTATION_MODE]: true,
    [F_MINIMALIST_MODE]: true,
    [F_TRACKED_LINKS]: true,
    [F_PDF_PAGE_ANALYTICS]: true,
    [F_DOWNLOAD_ANALYTICS]: true,
    [F_PDF_TO_WEBSITE]: true,
    [F_EMAIL_WHITELIST]: true
  }
}

export default PRO_U_PLAN
